import React from 'react';
import Banner from '../components/Banner';
import AudiencePaths from '../components/AudiencePaths';
import Benefits from '../components/Benefits';
import JoinSection from '../components/JoinSection';
import '../styles/Home.css';

function Home() {
  return (
    <main className="home-page">
      <Banner />
      <AudiencePaths />
      <Benefits />
      <JoinSection />
    </main>
  );
}

export default Home;
